import React, { ReactElement, useEffect, createRef } from "react";

interface Props {
  id: string;
  name: string;
  containerClass?: string;
  containerStyle?: React.CSSProperties;
  value?: string;
  className?: string;
  required?: boolean;
  placeholder?: string;
  innerRef?: React.LegacyRef<HTMLTextAreaElement>;
  inputStyle?: React.CSSProperties;
  readOnly?: boolean;
  disabled?: boolean;
  dataValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fucus?: boolean;
  type?: "text" | "number" | "password";
  autoComplete?: "current-password";
}

export default function TextField(props: Props): ReactElement {
  const {
    containerClass = "w-full",
    containerStyle,
    id,
    name,
    value,
    className,
    required,
    placeholder,
    inputStyle,
    readOnly = false,
    disabled = false,
    dataValue = "",
    onChange,
    fucus = false,
    type = "text",
    autoComplete,
  } = props;
  const ref = createRef<HTMLInputElement>();

  useEffect(() => {
    if (fucus && ref.current) {
      ref.current.focus();
    }
  }, []);

  return (
    <div className={containerClass} style={containerStyle}>
      <input
        ref={ref}
        className={className}
        type={type}
        defaultValue={value}
        name={name}
        id={id}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        style={inputStyle}
        data-value={dataValue}
        readOnly={readOnly}
        autoComplete={autoComplete}
        onChange={(e) => onChange && onChange(e)}
      />
    </div>
  );
}
